import React from 'react';

const PortalDataContext = React.createContext({authToken: undefined, user: undefined});

export { PortalDataContext };